.modal {
    /* max-width: 954px; */
}
  
  .modalHeader {
    padding: 2rem 0 0 1.5rem;
  }
  
  .modalBody {
    padding: 1.5rem 1.5rem;
  }
  
  .logo {
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: 1px;
  }
  
  .closeButton {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--static-text-standard);
  }
  
  .invoiceHeader {
    margin-bottom: 2rem;
  }

  .companyInfo {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .companyInfo h3 {
    /* margin: 0 0 0.5rem 0; */
    font-size: var(--fs-normal);
    color: var(--static-text-strong);
    font-weight: 600;
  }
  
  .companyInfo p {
    /* margin: 0.25rem 0; */
    color: var(--static-text-standard);
    font-size: var(--fs-small);
    font-weight: 400;
  }
  
  .email {
    color: var(--primary-enabled) !important;
  }

  .billToInfo {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .billToInfo h4 {
    /* margin: 0 0 0.5rem 0; */
    font-size: var(--fs-normal);
    color: var(--static-text-strong);
    font-weight: 600;
  }
  
  .billToInfo h3 {
    font-size: var(--fs-normal);
    color: var(--static-text-strong);
    /* font-weight: 600; */
  }
  
  .billToInfo p {
    color: var(--static-text-standard);
    font-size: var(--fs-small);
    font-weight: 400;
  }
  
  .invoiceInfo {
    min-width: 200px;
  }

  .value {
    font-weight: 400;
    color: var(--static-text-standard);
    font-size: var(--fs-small);
  }
  
  .label {
    font-weight: 600;
    color: var(--static-text-strong);
    font-size: var(--fs-small);
  }
  
  .invoiceTable {
    width: 100%;
    margin: 1.5rem 0;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .invoiceTable table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .invoiceTable th {
    background-color: var(--static-background-weak);
    padding: 0.75rem;
    text-align: left;
    font-weight: 500;
    color: var(--static-text-standard);
  }
  
  .invoiceTable td {
    padding: 0.75rem;
    border-bottom: 1px solid var(--static-border-weak);
    color: var(--static-text-standard);
  }
  
  .dateColumn {
    width: 15%;
  }
  
  .descriptionColumn {
    width: 30%;
  }
  
  .qtyColumn, .priceColumn, .discountColumn, .totalColumn {
    width: 12%;
  }
  
  .totals {
    width: 100%;
    padding: 1rem;
    border: 1px solid var(--static-divider-standard);
    border-radius: 8px;
  }

  .subLabel {
    
  }
  
  .amountDue {
    margin-top: 0.5rem;
    padding: 0.5rem;
    background-color: var(--static-background-weak);
    border-radius: 4px;
  }
  
  .notes {
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px dashed var(--static-border-standard);
    color: var(--static-text-weak);
    font-size: var(--fs-small);
  }
  
  .notesLabel {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .footer {
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem 1.5rem;
  }